(() => {
  if (window.kalzenHeroMediaInitialized) return;
  window.kalzenHeroMediaInitialized = true;
  const controllers = new Map();

  function attach(video) {
    if (controllers.has(video)) return;
    const mode = video.dataset.kzResponsiveVideo;
    const viewport = window.matchMedia(mode === 'mobile' ? '(max-width: 749px)' : '(min-width: 750px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const deferred = video.hasAttribute('data-kz-defer-video');
    let inRange = !deferred || !('IntersectionObserver' in window);
    let loaded = false;

    function update() {
      const visible = mode === 'all' || viewport.matches;
      if (visible && inRange && video.dataset.kzPoster) video.setAttribute('poster', video.dataset.kzPoster);
      const shouldPlay = visible && inRange && !reducedMotion.matches;
      if (shouldPlay && !loaded) {
        if (video.dataset.kzSrc) video.setAttribute('src', video.dataset.kzSrc);
        video.querySelectorAll('source[data-kz-src]').forEach(source => source.setAttribute('src', source.dataset.kzSrc));
        loaded = true;
        video.load();
      } else if ((!visible || reducedMotion.matches) && loaded) {
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source[data-kz-src]').forEach(source => source.removeAttribute('src'));
        loaded = false;
        video.load();
      }
      if (shouldPlay) {
        video.muted = true;
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {});
      } else {
        video.pause();
      }
      if (!visible) video.removeAttribute('poster');
    }

    viewport.addEventListener('change', update);
    reducedMotion.addEventListener('change', update);
    const observer = deferred && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      inRange = entries.some(entry => entry.isIntersecting);
      update();
    }, { rootMargin: '200px 0px' }) : null;
    observer?.observe(video.closest('[data-kz-mode-switcher]') || video);
    controllers.set(video, () => {
      viewport.removeEventListener('change', update);
      reducedMotion.removeEventListener('change', update);
      observer?.disconnect();
      video.pause();
    });
    update();
  }

  function init(root = document) {
    root.querySelectorAll('video[data-kz-responsive-video]').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [video, cleanup] of controllers) {
      if (event.target.contains(video)) { cleanup(); controllers.delete(video); }
    }
  });
})();
